import { headerStyles as styles } from "@insite/content-library/Pages/Header";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, gutter, mediaQueriesBP } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    padding: 0,
};

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        background-color: ${getColor(colorStrings.primaryMain)};
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 ${gutter}px;

        > div:last-child {
            display: flex;
            align-items: center;
            justify-content: center;
            height: auto;
            max-width: max-content;

            ${mediaQueriesBP.minMD} {
                max-width: 150px;
            }
        }

        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 50%;
            right: 50%;
            height: 100%;
            background-color: ${getColor(colorStrings.primaryMain)};
            z-index: -1;
            width: 100vw;
            transform: translateX(-50%);
        }

        > div:last-child {
            justify-content: flex-end;
        }
    `,
};
